console.log('global.js loaded');

// Define CartAddEvent class to integrate with theme's cart system
// This matches the CartAddEvent class from events.js
class CartAddEvent extends Event {
    /**
     * Creates a new CartAddEvent
     * @param {Object} resource - The cart object
     * @param {string} sourceId - The id of the element the action was triggered from
     * @param {Object} data - Additional event data
     * @param {string} [data.source] - The source of the cart update
     * @param {number} [data.itemCount] - The number of items added
     * @param {string} [data.variantId] - The variant id that was added
     */
    constructor(resource, sourceId, data) {
        super('cart:update', { bubbles: true });
        this.detail = {
            resource,
            sourceId,
            data: {
                ...data,
            },
        };
    }
}

/**
 * Function to show notifications
 * @param {string} message - The notification message
 * @param {'info' | 'success' | 'error' | 'warning'} [type='info'] - The notification type
 */
function showNotification(message, type = 'info') {
    // Create notification element
    const notification = document.createElement('div');
    notification.className = `notification notification-${type}`;
    notification.textContent = message;
    
    // Style the notification
    notification.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        padding: 15px 20px;
        border-radius: 5px;
        color: white;
        font-weight: 500;
        z-index: 9999;
        opacity: 0;
        transform: translateX(100%);
        transition: all 0.3s ease;
        max-width: 300px;
        word-wrap: break-word;
    `;
    
    // Set background color based on type
    switch(type) {
        case 'success':
            notification.style.backgroundColor = '#28a745';
            break;
        case 'error':
            notification.style.backgroundColor = '#dc3545';
            break;
        case 'warning':
            notification.style.backgroundColor = '#ffc107';
            notification.style.color = '#000';
            break;
        default:
            notification.style.backgroundColor = '#007bff';
    }
    
    // Add to page
    document.body.appendChild(notification);
    
    // Animate in
    setTimeout(() => {
        notification.style.opacity = '1';
        notification.style.transform = 'translateX(0)';
    }, 100);
    
    // Remove after 3 seconds
    setTimeout(() => {
        notification.style.opacity = '0';
        notification.style.transform = 'translateX(100%)';
        setTimeout(() => {
            if (notification.parentNode) {
                notification.parentNode.removeChild(notification);
            }
        }, 300);
    }, 3000);
}

// Make showNotification globally accessible
window.showNotification = showNotification;

// Make addToCart globally accessible
window.addToCart = function(event, variantId) {
    console.log('Adding variant to cart:', variantId);
    
    // Show loading state
    const button = /** @type {HTMLButtonElement} */ (event.target);
    if (!button) return;
    
    // Save original HTML to restore later (preserves icons and structure)
    const originalHTML = button.innerHTML;
    
    // Find text node or span containing text and update only the text
    const textElement = button.querySelector('.button-text, .add-to-cart-text__content, span');
    if (textElement) {
        textElement.textContent = 'Adding...';
    } else {
        // If no text element found, update entire button
        button.textContent = 'Adding...';
    }
    
    button.disabled = true;
    
    // Prepare the form data
    const formData = new FormData();
    formData.append('id', variantId.toString());
    formData.append('quantity', '1');
    
    // Make the AJAX request
    // Note: Don't set Content-Type header - browser will set it automatically for FormData
    fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        }
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    })
    .then(data => {
        console.log('Product added to cart:', data);
        
        // Update button text to success (preserve icon)
        const textElement = button.querySelector('.button-text, .add-to-cart-text__content, span');
        if (textElement) {
            textElement.textContent = 'Added!';
        } else {
            button.textContent = 'Added!';
        }
        button.style.backgroundColor = '#28a745';
        
        // Dispatch the theme's CartAddEvent to update cart count automatically
        // This will trigger the existing cart icon to update
        document.dispatchEvent(
            new CartAddEvent({}, variantId.toString(), {
                source: 'custom-add-to-cart',
                itemCount: 1,
                variantId: variantId.toString(),
            })
        );
        
        // Show success message
        showNotification('Product added to cart!', 'success');
        
        // Reset button after 2 seconds
        setTimeout(() => {
            button.innerHTML = originalHTML; // Restore original HTML with icon
            button.disabled = false;
            button.style.backgroundColor = '';
        }, 2000);
    })
    .catch(error => {
        console.error('Error adding to cart:', error);
        
        // Update button text to error (preserve icon)
        const textElement = button.querySelector('.button-text, .add-to-cart-text__content, span');
        if (textElement) {
            textElement.textContent = 'Error';
        } else {
            button.textContent = 'Error';
        }
        button.style.backgroundColor = '#dc3545';
        
        // Show error message
        showNotification('Failed to add product to cart', 'error');
        
        // Reset button after 2 seconds
        setTimeout(() => {
            button.innerHTML = originalHTML; // Restore original HTML with icon
            button.disabled = false;
            button.style.backgroundColor = '';
        }, 2000);
    });
}